<template>
  <div>
    <div class="top-box">
      <el-button type="primary" @click="addType" size="small">添加</el-button>
      <div class="search-box">
        <el-input v-model="keywords" placeholder="请输入查询类型名" size="small"></el-input>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </div>
    </div>
    <div class="table-box">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="200" align="center" :index="indexMethod">
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center">
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="warning" @click="EditType(scope.row)" size="small">编辑</el-button>
            <el-button type="danger" size="small" @click="DeleteType(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-box">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
        @current-change="handleCurrentChange" @prev-click="prevCilck" @next-click="nextCilck" :current-page.sync="page">
      </el-pagination>
    </div>
    <div v-if="DialogVisible">
      <el-dialog :title="DialogTitle" :visible.sync="DialogVisible" width="35%" :destroy-on-close="true">
        <AddType v-on:onDialog="upDialogStatus" v-bind:editID="editID"></AddType>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AddType from "./addType.vue";
export default {
  components: {
    AddType,
  },
  data() {
    return {
      keywords: "",
      tableData: [],
      DialogVisible: false,
      DialogTitle: "",
      editID: 0,
      total: 0,
      page: 1,
      pageSize: 10,
    };
  },
  methods: {
    addType() {
      this.DialogVisible = true;
      this.DialogTitle = "添加类型";
      this.editID = 0;
    },
    EditType(e) {
      console.log(e.Id);
      this.DialogVisible = true;
      this.DialogTitle = "修改类型";
      this.editID = e.id;
    },
    async onSearch() {
      this.page = 1;
      const { data: res } = await this.$axios.post("/type", {
        keywords: this.keywords,
        page: this.page,
        pageSize: this.pageSize,
      });
      console.log(res);
      this.tableData = res.data.list;
      this.total = res.data.total;
    },
    async DeleteType(e) {
      console.log(e);
      const { data: res } = await this.$axios.post("/type/deltype", e);
      console.log(res);
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
      this.getTypeList();
      return this.$message.success(res.meta.msg);
    },
    upDialogStatus(e) {
      this.DialogVisible = e;
      this.getTypeList();
    },
    async getTypeList() {
      const { data: res } = await this.$axios.post("/type", {
        keywords: this.keywords,
        page: this.page,
        pageSize: this.pageSize,
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      console.log(res);
    },
    async handleCurrentChange(page) {
      this.page = page;
      const { data: res } = await this.$axios.post("/type", {
        keywords: this.keywords,
        page: this.page,
        pageSize: this.pageSize,
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      console.log(res);
    },
    async prevCilck(page) {
      console.log(page);
      this.page = page;
      const { data: res } = await this.$axios.post("/type", {
        keywords: this.keywords,
        page: this.page,
        pageSize: this.pageSize,
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      console.log(res);
    },
    async nextCilck(page) {
      console.log(page);
      this.page = page;
      const { data: res } = await this.$axios.post("/type", {
        keywords: this.keywords,
        page: this.page,
        pageSize: this.pageSize,
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      console.log(res);
    },
    indexMethod(index){
      if(this.total<this.pageSize){
        return this.total - index;
      }else{
        return (this.total - ((this.page - 1) * this.pageSize) -index);
      }
    }
  },
  created() {
    this.getTypeList();
  },
};
</script>

<style lang="less">
.top-box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .search-box {
    display: flex;
    align-items: center;

    .el-input {
      min-width: 350px;
      margin-right: 10px;
    }
  }
}

.table-box {
  margin-top: 20px;
}

.page-box {
  margin-top: 10px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/articleType/articleType.vue